import { Loader2 } from "lucide-react";

export default function PageLoadingTrigger({
  pageRef,
  isFetchingNextPage,
  hasNextPage,
  label = "leads",
}: {
  pageRef: React.Ref<Element | null>;
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
  label?: string;
}) {
  return (
    <div
      ref={pageRef as React.Ref<HTMLDivElement | null>}
      className="w-full flex justify-center items-center py-4 h-16"
    >
      {isFetchingNextPage ? (
        <div className="flex items-center gap-2 text-sm text-[var(--color-black-6)]">
          <Loader2 className="animate-spin size-4 text-[var(--color-primary)]" />
          <span>Loading more {label}...</span>
        </div>
      ) : hasNextPage ? (
        <span className="opacity-0">Load Trigger</span>
      ) : null}
    </div>
  );
}
